/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import {SurveySectionFooter} from "./SurveySectionFooter";
import {Col, Row, Table} from "react-bootstrap";
import {SurveySectionHeader} from "./SurveySectionHeader";
import {SurveyFormQuestion} from "./Inputs/SurveyFormQuestion";
import React, {useCallback, useMemo} from "react";
import {allSurveyQuestions, useOnlyWhen} from "../../../../../monitoring/src/Hooks/SharedSurveyHooks";

export const SurveyFormSection = (props) => {
    
    // pass-through event handlers
    const {
        
    } = props;
    
    const {
        conservationAction,
        survey,
        customSections,
        customData,
        editMode,
        validation = {},
        getQuestionAnswer,
        answers,
        friendlyAnswers,
        section,
        
        isLastSection = false,
        isValid,
        
        /* handlers */
        DeleteAnswer, OnAnswerChange,
        OnConservationActionChange, OnCustomDataChange,
        OnFinish, OnSave, OnValidation
        
        
        
    } = props;
    
    const {isFieldVisible, getVisibleQuestions} = useOnlyWhen();
    
    const getQuestionValidation = useCallback((question) => {
        if (question.surveyQuestionId in validation) {
            return validation[question.surveyQuestionId];
        }
        
        return null;
    }, [JSON.stringify(validation)]);
    
    const surveySectionFooter = <SurveySectionFooter
        editMode={editMode}
        isLastSection={isLastSection}
        onSaveAndFinish={OnFinish}
        isValid={isValid}
    />;
    
    if(customSections) {
        if(customSections[section.code]) {
            let overrides = {
                component: customSections[section.code]
            };
            
            return <overrides.component
                key={section.surveySectionId}
                id={"sb-survey-section-" + section.surveySectionId}
                className="sb-survey-section"
                Survey={survey}
                Section={section}
                EditMode={editMode}
                IsValid={isValid}
                ConservationAction={conservationAction}
                GetQuestionAnswer={getQuestionAnswer}
                GetQuestionValidation={getQuestionValidation}
                CustomData={customData}
                OnAnswerChange={OnAnswerChange}
                OnValidation={OnValidation}
                DeleteAnswer={DeleteAnswer}
                OnConservationActionChange={OnConservationActionChange}
                OnCustomDataChange={OnCustomDataChange}
                OnSave={OnSave}
                OnFinish={OnFinish}
                Footer={surveySectionFooter}
            />;
        }
    }
    
    const questions = useMemo(() => {
            const questions = getVisibleQuestions(section?.SurveyQuestions, friendlyAnswers)
            if(questions) {
                return questions
                    .filter(question => isFieldVisible(question.options, friendlyAnswers))
                    .sort((a, b) => Number(a.order) - Number(b.order));
            }
            
            return [];
        },
        [section.SurveyQuestions, getVisibleQuestions, friendlyAnswers, isFieldVisible]
    );
    
    return <Col key={section.surveySectionId}
                id={"sb-survey-section-" + section.surveySectionId}
                className="sb-survey-section">
        <SurveySectionHeader section={section}/>
        <Row>
            <Col xs={12}>
                <Table className="sb-survey-form-table" striped bordered>
                    <tbody>
                    {
                        questions.map((question) => <SurveyFormQuestion
                            conservationAction={conservationAction}
                            editMode={editMode}
                            key={question.surveyQuestionId}
                            surveyTypeId={survey.surveyTypeId}
                            question={question}
                            
                            getQuestionValidation={getQuestionValidation}
                            getQuestionAnswer={getQuestionAnswer}
                            
                            DeleteAnswer={DeleteAnswer}
                            OnAnswerChange={OnAnswerChange}
                            
                            OnConservationActionChange={OnConservationActionChange}
                            OnCustomDataChange={OnCustomDataChange}
                            
                            OnFinish={OnFinish}
                            OnSave={OnSave}
                            OnValidation={OnValidation}
                        
                        />)
                    }
                    </tbody>
                </Table>
            </Col>
        </Row>
        {surveySectionFooter}
    </Col>;
};

